import React, { useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import LoadThemeComponent from '../../../../base/LoadThemeComponent';
import { formatCurrency } from '../../../../utils/formatCurrency';
import { isDefault } from '../../../../utils/template';
import { SelectSignalPick } from '../../Types/Types';
import { getNonEmptyLines } from '../../helpers/linesHelper';
import useLinesHelper from '../../helpers/useLinesHelper';

import { RootState } from '../../redux/store';

import Line from './Line';

type Props = {
    numbersToPick: number;
    setSelectSignal?: (value: SelectSignalPick) => void;
};

function SelectedLines({ numbersToPick, setSelectSignal }: Props) {
    const { t } = useTranslation();
    const { lines, stakes, lottery, addEmptyLine } = useLinesHelper();
    const { linePriceGross } = useSelector((state: RootState) => state.playStore);

    const { removeAllLines } = useLinesHelper();

    useLayoutEffect(() => {
        const nonEmptyLines = getNonEmptyLines(lines);

        // add empty line if there is none and it does not exceed maxLinesPerTicket
        if (isDefault() && lines.length === nonEmptyLines.length && nonEmptyLines.length < lottery.maxLinesPerTicket) {
            addEmptyLine();
        }
    }, [lines]);

    const baseView = () => (
        <div className="form-mobile row justify-content-md-center w-100">
            {lines.map((line, i) => {
                return <Line key={i} index={i} numbers={line} numbersToPick={numbersToPick} stake={stakes[i]} />;
            })}
        </div>
    );

    const defaultView = () => (
        <div className="form-mobile justify-content-md-center w-100">
            <div className="message-box d-flex justify-content-between">
                <span>
                    {t('playPicker.modal.selectedLines', {
                        linePrice: formatCurrency(linePriceGross, 2, lottery.currencyCode),
                        selectedCount: lines.length - 1,
                    })}
                </span>
                <span className="clear-all fw-bold text-decoration-underline" onClick={() => removeAllLines()}>
                    {t('playPicker.clearAll')}
                </span>
            </div>
            {lines.map((line, i) => {
                return (
                    <Line
                        key={i}
                        index={i}
                        numbers={line}
                        numbersToPick={numbersToPick}
                        stake={stakes[i]}
                        setSelectSignal={setSelectSignal}
                    />
                );
            })}
        </div>
    );

    function getContent() {
        if (lines === null || lines.length === 0) {
            return null;
        }
        return <LoadThemeComponent defaultView={defaultView} baseView={baseView} />;
    }

    return getContent();
}

export default SelectedLines;
